import type { Config } from ".";

const config: Omit<Config, "supportedStaticConfigurationSchemaMajor" | "operationTimeout" | "uploads"> = {
    environment: "Production",
    apiEndpoint: "/netzanschluss/api/v1",
    firebaseConfig: {
        apiKey: "AIzaSyBeNTvAQi1dwcrgJnEDbxP7k4KjWcX_A94",
        authDomain: "hoechst-digital-p.firebaseapp.com",
        databaseURL: "https://hoechst-digital-p.firebaseio.com",
        projectId: "hoechst-digital-p",
        storageBucket: "nap-production-documents",
        messagingSenderId: "298046672966",
        appId: "1:298046672966:web:faed89591c4c7724be7a47",
        measurementId: "G-0RLVGEF9P4",
    },
};

export default config;
